import PropTypes from 'prop-types';
import styles from './button-print.module.scss';
import Icon from '../icon/index';
import InteractiveElement from '../interactive-element';

const ButtonPrint = ({ className, iconStyle, icon }) => {
  const classes = [className, styles.button].filter(Boolean).join(' ');
  const iconVariant = icon || 'Printer';
  return (
    <InteractiveElement
      as="button"
      className={classes}
      data-analytics-linkname="print"
      onClick={window.print}
      aria-label="print"
    >
      <Icon variant={iconVariant} className={iconStyle} />
    </InteractiveElement>
  );
};

ButtonPrint.propTypes = {
  className: PropTypes.string,
  iconStyle: PropTypes.string,
  icon: PropTypes.string
};

export default ButtonPrint;
